import { action, observable, runInAction, computed, toJS } from 'mobx'
import BaseStore from '@common/Table/store'
import Api from '@api/xi_feng/jiamengGoods.js'
import SetMealApi from '@api/setMeal'
import { Modal, message } from 'hljd'
import { isStoreAccount, isStoreHidden } from '@util'
import { PUBLISH_MEAL_PATH_A } from '@constant'
class Store extends BaseStore {
  property_id
  @observable status = '1'
  @observable title = ''
  @observable statusCount = {}

  $listApi = Api.getSetMealList
  $pageSize = 1000

  @computed
  get listLen() {
    return this.$list.length
  }

  @action
  setStoreData = (type, value) => {
    this[type] = value
  }

  $getParams = () => {
    let status = ''
    if (this.status == 1) {
      status = '1'
    } else if (this.status == 2) {
      status = '0'
    } else if (this.status == 3) {
      status = '3'
    }
    return {
      commodity_type: 0,
      is_sold_out: this.status == 4 ? 1 : 0,
      property_id: this.property_id,
      title_search: this.title,
      status
    }
  }
  $extraOp = () => {
    this.getStatusCount()
  }

  @action
  onTableChane = value => {
    this.status = value
    this.$getList()
  }

  //普通套餐编辑
  setMealEditFn = (id, rule, second_category_id, property_id) => {
    if (rule) {
      return Modal.info({
        content: '商品在活动中不能编辑'
      })
    } else {
      let msg = isStoreHidden()
      if (msg != 'success') {
        message.error(msg)
      } else {
        this.getEditSession(id, second_category_id, property_id)
      }
    }
  }
  @action
  getEditSession = async (id, second_category_id, property_id) => {
    //这段是为了填之前的人写的发布套餐的坑
    const { data, success } = await Api.editApi(id)
    runInAction(() => {
      if (success) {
        if (data.merchandiseParams) {
          sessionStorage.setItem(
            'mySetmeal_tabLength',
            JSON.stringify(data.merchandiseParams)
          )

          let url = `${PUBLISH_MEAL_PATH_A}?id=${id}`

          // 门店账号，则需要拼 propertyId
          if (isStoreAccount()) {
            url += `&propertyId=${property_id}`
          }

          if (second_category_id) {
            url += `&weddingPhotoType=${second_category_id}`
          }

          window.location.href = url
        }
      }
    })
  }

  @action
  SoldOutGood = async (id, type) => {
    // 上架
    let params = { id }
    if (type == '0') {
      params.sold_out = 1
    } else {
      params.sold_out = 0
    }
    const { success } = await Api.soldOut(params)
    if (success) {
      this.$getList()
    }
  }

  //删除普通套餐
  deleteSetMeal = async id => {
    const { success } = await Api.deleteSetMeal({ id })
    if (success) {
      this.$getList()
    }
  }

  @action
  orderFn = async (id, index, direction) => {
    let orderId = ''
    if (direction == 'up') {
      if (index == 0) {
        return
      }
      orderId = toJS(this.$list)[index - 1].id
    } else if (direction == 'down') {
      if (index === this.$list.length - 1) {
        return
      }
      orderId = toJS(this.$list)[index + 1].id
    } else {
      orderId = toJS(this.$list)[0].id
    }
    let set_meal_ids = []
    set_meal_ids.push(id, orderId)
    let params = {
      set_meal_ids: set_meal_ids.join()
    }
    let { success } = await SetMealApi.changeOrder(params)
    if (success) {
      this.$getList()
    }
  }

  // 置顶
  @action
  orderTop = async id => {
    let { success } = await Api.toTopApi({ id, is_top: 1 })
    if (success) {
      this.$getList()
    }
  }

  @action
  search = () => {
    this.$getList()
  }

  @action
  getStatusCount = async () => {
    let { success, data } = await Api.getStatusCount({
      property_id: this.property_id
    })
    if (success) {
      this.statusCount = data
    }
  }

  // 修改热门标签
  @action
  changeHotTag = async (id, value, property_id) => {
    const { success } = await Api.changeHotTag({
      set_meal_id: id,
      hot_tag: value,
      property_id
    })
    if (success) {
      this.$getList()
    }
  }

  @action
  reset = () => {
    this.status = '1'
    this.title = ''
    this.statusCount = {}
  }
}

export default Store
